import type {ClientUser} from "../API";


export function getFullName(user: ClientUser): string {
    if (!user.surname) {
        return user.email;
    }
    return `${user.name || ''} ${user.surname}`.trim();
}

export function getFullNameOrEmpty(user: ClientUser): string {
    return `${user.name || ''} ${user.surname || ''}`.trim();
}

export function getAbbreviate(user: ClientUser): string {
    const name = user.email;
    return `${name.charAt(0)}${name.charAt(1)}`;
}

export function hasOtherActiveUsers(activitySet: Set<string>, targetUserId: string) {
    if (activitySet.size > 1) {
        return true;
    } else if (activitySet.size === 1) {
        return !activitySet.has(targetUserId)
    }

    return false;
}
